module.exports = __webpack_public_path__ + "static/media/php-color.828f7169.png";